<button
  data-id="searchUserDetailsBtn"
  mat-icon-button
  matTooltip="Find user details"
  (click)="findUserDetailsOn = !findUserDetailsOn">
  @if (!newIcon) {
    <i class="fas fa-user-ninja" style="font-size: 24px"></i>
  }
  @if (newIcon) {
    <img class="header-icons" src="assets/icon/search.svg" />
  }
</button>

@if (findUserDetailsOn) {
  <div cdkDrag class="lm-widget">
    <h3>
      <span>User Ninja</span>
      <button mat-icon-button (click)="findUserDetailsOn = false">
        <i class="fas fa-user-ninja" style="font-size: 16px"></i>
      </button>
    </h3>
    <form [formGroup]="form" class="example-form" (submit)="search()">
      <div style="display: flex; flex-direction: row">
        @if (cohortIcon) {
          <img class="cohort-icon" [src]="cohortIcon" />
        }
        <mat-form-field class="example-full-width" style="font-size: 16px">
          <mat-label>Id</mat-label>
          <input data-id="searchInputPlayerId" formControlName="id" matInput />
          <mat-icon matSuffix matTooltip="Copy to clipboard" (click)="copyOne('id')">file_copy</mat-icon>
          <mat-icon matSuffix (click)="clearOne('id')">clear</mat-icon>
        </mat-form-field>
      </div>
      <mat-form-field class="example-full-width" style="font-size: 16px">
        <input formControlName="email" matInput />
        <mat-label>Email</mat-label>
        <mat-icon matSuffix matTooltip="Copy to clipboard" (click)="copyOne('email')">file_copy</mat-icon>
        <mat-icon matSuffix (click)="clearOne('email')">clear</mat-icon>
      </mat-form-field>
      <mat-form-field class="example-full-width" style="font-size: 16px">
        <mat-label>First name</mat-label>
        <input formControlName="firstName" matInput />
        <mat-icon matSuffix (click)="clearOne('firstName')">clear</mat-icon>
      </mat-form-field>
      <mat-form-field class="example-full-width" style="font-size: 16px">
        <mat-label>Last name</mat-label>
        <input formControlName="lastName" matInput p />
        <mat-icon matSuffix (click)="clearOne('lastName')">clear</mat-icon>
      </mat-form-field>
      <mat-form-field class="example-full-width" style="font-size: 16px">
        <mat-label>Mobile number (Min 4 digits)</mat-label>
        <input formControlName="phoneNumber" matInput />
        <mat-icon matSuffix (click)="clearOne('phoneNumber')">clear</mat-icon>
      </mat-form-field>
      <div>
        <button
          [disabled]="!searchEnabled || !form.valid"
          mat-mini-fab
          data-id="searchBtn"
          matTooltip="Search"
          style="margin-right: 10px"
          color="primary">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-mini-fab matTooltip="Clear" color="warn" (click)="clear()" type="reset" style="margin-right: 10px">
          <mat-icon>clear_all</mat-icon>
        </button>
        <a href="javascript:void(0)">
          <button
            data-id="openPlayerDetailsBtn"
            mat-mini-fab
            matTooltip="Player details"
            color="primary"
            (click)="goTo()"
            type="button">
            <mat-icon>link</mat-icon>
          </button>
        </a>
        <span style="padding-left: 10px">{{ message }}</span>
      </div>
    </form>
    @if (list) {
      <div class="more">
        <h6>
          <span>More results</span>
          <a (click)="showMore = !showMore">{{ showMore ? 'Hide' : 'Show' }}</a>
        </h6>
        @if (showMore) {
          <div>
            @for (element of list; track element; let i = $index) {
              <a (click)="setElement(i)"
                ><img class="smaller-cohort-icon" [src]="getIcon(element.cohortId)" /> {{ element.id }},
                {{ element.email }}</a
              >
            }
          </div>
        }
      </div>
    }
  </div>
}
